import React from 'react';
import { AlertTriangle } from 'lucide-react';

export const ErrorDisplay = ({ title, message }) => (
    <div className="bg-red-900/50 p-6 rounded-lg border border-red-700">
        <div className="flex items-center">
            <AlertTriangle className="w-8 h-8 text-red-400 mr-4 flex-shrink-0" />
            <div>
                <h3 className="text-lg font-bold text-white">{title}</h3>
                <p className="text-red-200 text-sm">{message}</p>
            </div>
        </div>
    </div>
);
